import { API } from 'aws-amplify';
import { API_NAME, getConfig, handleError, validateResponse } from './apiUtils';

export function getRaffleReport(country, category, brand, fromDate, toDate) {
    const path = `/v1/loyaltyadmin/${country}/${category}/${brand}/report/raffle?fromDate=${fromDate}&toDate=${toDate}`;
    return getConfig()
        .then((config) => API.get(API_NAME, path, config))
        .then(validateResponse)
        .catch(handleError);
}

export function getWinnersReport(country, category, brand, fromDate, toDate) {
    const path = `/v1/loyaltyadmin/${country}/${category}/${brand}/report/prize-redeem?fromDate=${fromDate}&toDate=${toDate}`;
    return getConfig()
        .then((config) => API.get(API_NAME, path, config))
        .then(validateResponse)
        .catch(handleError);
}
